import { newAssociationCommand } from './new-association';
import { newInspectionCommand } from './new-inspection';
import { newQuoteCommand } from './new-quote';
import { newTaskCommand } from './new-task';
import { newWorkOrderCommand } from './new-work-order';
import { quickTaskCommand } from './quick-task';
import type { Command, CommandRegistry } from './types';

// Register all available commands
const commands: Command[] = [
	newWorkOrderCommand,
	newAssociationCommand,
	newInspectionCommand,
	newQuoteCommand,
	newTaskCommand,
	quickTaskCommand,
];

// Group commands by category
export const commandRegistry: CommandRegistry = commands.reduce((registry, command) => {
	if (!registry[command.category]) {
		registry[command.category] = [];
	}
	registry[command.category].push(command);
	return registry;
}, {} as CommandRegistry);

// Get all commands
export const getAllCommands = (): Command[] => commands;

// Get commands by category
export const getCommandsByCategory = (category: string): Command[] => {
	return commandRegistry[category] || [];
};

// Search commands by query
export const searchCommands = (query: string): Command[] => {
	const lowercaseQuery = query.toLowerCase();

	return commands.filter(command => {
		// Search in title, description, and keywords
		const searchableText = [
			command.title,
			command.description,
			...(command.keywords || []),
		].join(' ').toLowerCase();

		return searchableText.includes(lowercaseQuery);
	});
};

// Get commands that match a specific command pattern (e.g., "new")
export const getCommandsByPattern = (pattern: string): Command[] => {
	const lowercasePattern = pattern.toLowerCase();

	return commands.filter(command => {
		// Check if command title starts with the pattern
		return command.title.toLowerCase().startsWith(lowercasePattern);
	});
};
